/**
 * Estimated Delivery Date Calculator
 *
 * Calculates and renders estimated delivery dates based on:
 * - Processing days (which days the shop processes orders)
 * - Cutoff time (orders after this time process next processing day)
 * - Delivery days count (transit time)
 * - Delivery days (which days carriers deliver)
 */

(function () {
  'use strict';

  function getOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  function formatDeliveryDate(date) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var dayName = days[date.getDay()];
    var dayNum = date.getDate();
    var monthName = months[date.getMonth()];
    return dayName + ' ' + dayNum + getOrdinalSuffix(dayNum) + ' ' + monthName;
  }

  function parseHolidays(arr) {
    if (!arr || !arr.length) return {};
    var holidays = {};
    for (var i = 0; i < arr.length; i++) {
      var d = arr[i].replace(/<br\s*\/?>/gi, '').trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(d)) holidays[d] = true;
    }
    return holidays;
  }

  function toDateKey(date) {
    var y = date.getFullYear();
    var m = ('0' + (date.getMonth() + 1)).slice(-2);
    var d = ('0' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
  }

  function calculateDeliveryDate(settings) {
    var processingDays = settings.processingDays || [1, 2, 3, 4, 5];
    var deliveryDays = settings.deliveryDays || [1, 2, 3, 4, 5, 6];
    var cutoffHour = settings.cutoffHour || 14;
    var cutoffMinute = settings.cutoffMinute || 0;
    var numDeliveryDays = settings.numDeliveryDays || 2;
    var timezone = settings.timezone || 'Europe/London';
    var processingHolidays = parseHolidays(settings.processingHolidays);
    var deliveryHolidays = parseHolidays(settings.deliveryHolidays);

    // Get current time in shop timezone
    var now = new Date();
    var shopTimeStr = now.toLocaleString('en-GB', { timeZone: timezone });
    // Parse "DD/MM/YYYY, HH:MM:SS"
    var parts = shopTimeStr.split(', ');
    var dateParts = parts[0].split('/');
    var timeParts = parts[1].split(':');

    var shopNow = new Date(
      parseInt(dateParts[2], 10),
      parseInt(dateParts[1], 10) - 1,
      parseInt(dateParts[0], 10),
      parseInt(timeParts[0], 10),
      parseInt(timeParts[1], 10),
      parseInt(timeParts[2], 10)
    );

    var currentDay = shopNow.getDay();
    var currentHour = shopNow.getHours();
    var currentMinute = shopNow.getMinutes();
    var isPastCutoff = currentHour > cutoffHour || (currentHour === cutoffHour && currentMinute >= cutoffMinute);

    // Step 1: Find processing date
    var processDate = new Date(shopNow);

    function isProcessingDay(date) {
      return processingDays.indexOf(date.getDay()) !== -1 && !processingHolidays[toDateKey(date)];
    }

    function isDeliveryDay(date) {
      return deliveryDays.indexOf(date.getDay()) !== -1 && !deliveryHolidays[toDateKey(date)];
    }

    if (isPastCutoff || !isProcessingDay(processDate)) {
      var daysChecked = 0;
      do {
        processDate.setDate(processDate.getDate() + 1);
        daysChecked++;
      } while (!isProcessingDay(processDate) && daysChecked < 60);
    }

    // Step 2: Count forward delivery days from the day after processing
    var deliveryDate = new Date(processDate);
    var counted = 0;

    while (counted < numDeliveryDays) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (isDeliveryDay(deliveryDate)) {
        counted++;
      }
    }

    return deliveryDate;
  }

  function initEstimatedDelivery(container) {
    var settingsEl = container.querySelector('[data-delivery-settings]');
    if (!settingsEl) return;

    var settings;
    try {
      settings = JSON.parse(settingsEl.textContent);
    } catch (e) {
      return;
    }

    var deliveryDate = calculateDeliveryDate(settings);
    var formatted = formatDeliveryDate(deliveryDate);

    var dateEl = container.querySelector('[data-delivery-date]');
    if (dateEl) {
      dateEl.textContent = formatted;
    }

    // Tooltip behaviour
    var trigger = container.querySelector('[data-delivery-tooltip-trigger]');
    var tooltip = container.querySelector('[data-delivery-tooltip]');
    if (!trigger || !tooltip) return;

    var isTouch = 'ontouchstart' in window;

    if (isTouch) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        tooltip.classList.toggle('is-visible');
      });
      document.addEventListener('click', function (e) {
        if (!container.contains(e.target)) {
          tooltip.classList.remove('is-visible');
        }
      });
    } else {
      trigger.addEventListener('mouseenter', function () {
        tooltip.classList.add('is-visible');
      });
      trigger.addEventListener('mouseleave', function () {
        tooltip.classList.remove('is-visible');
      });
      trigger.addEventListener('focus', function () {
        tooltip.classList.add('is-visible');
      });
      trigger.addEventListener('blur', function () {
        tooltip.classList.remove('is-visible');
      });
    }
  }

  // Initialise all instances on the page
  function init() {
    var containers = document.querySelectorAll('[data-estimated-delivery]');
    for (var i = 0; i < containers.length; i++) {
      initEstimatedDelivery(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section events (customizer live preview)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
